module.exports = __webpack_public_path__ + "static/media/LogoCandidate.1d51989f.svg";